import React from "react";
import { CircleAlertIcon } from "lucide-react";
import { problemList } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
export function ProblemSection() {
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-226" data-mp="8ipjore7kcju">
      <div className="mx-auto max-w-3xl" data-id="element-227" data-mp="dj4xtl6bdo2v">
        <SectionHeading eyebrow="Introducing the Endo Blueprint™" title="A Visual Framework for Organizing Endodontic Knowledge" data-id="element-228" data-mp="dhtrbdlhi282" />
        <div className="mt-8 space-y-5 text-lg leading-relaxed text-ink/85" data-id="element-229" data-mp="3lh0qol8k4hj">
          <p data-id="element-230" data-mp="3je07amgisyk">The problem isn't necessarily that you need another textbook.</p>
          <p data-id="element-231" data-mp="3lt6eyddqr42a">You may already have notes, clinical references, courses, and years of education.</p>
          <p data-id="element-232" data-mp="3qqor0cn21zei">
            What you may need is <strong className="text-ink" data-id="element-233" data-mp="1jzyyh0me6get">a clearer way to connect that information</strong> when
            reviewing a case. A practical, visual system that brings the major concepts of endodontics together in one
            organized reference.
          </p>
        </div>

        <div className="mt-16" data-id="element-234" data-mp="1nlqa0l6au51c">
          <SectionHeading eyebrow="The Problem" title="From Reviewing Endless References to Following a Structured Process" data-id="element-235" data-mp="1iozzseh6e3nu" />
          <p className="mt-6 text-lg leading-relaxed text-ink/85" data-id="element-236" data-mp="1wi92xxej5sxx">
            You may already know the terminology and understand the principles of instrumentation, irrigation, obturation,
            and diagnosis. But knowing the individual concepts doesn't automatically tell you how to organize the
            available information. <strong className="text-ink" data-id="element-237" data-mp="1dpn7vfbg66ee">You may find yourself:</strong>
          </p>
          <ul className="mt-6 divide-y divide-line rounded-2xl border border-line bg-paper" data-id="element-238" data-mp="1dnalmpynp9vj">
            {problemList.map(item => <li key={item} className="flex gap-3 p-4 text-[17px] leading-snug text-ink" data-id="element-239" data-mp="2p40wime0ypvh">
                <CircleAlertIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-240" data-mp="2k68swv40pfbg" />
                {item}
              </li>)}
          </ul>
          <div className="mt-8 space-y-3 text-lg leading-relaxed text-ink/85" data-id="element-241" data-mp="1hunr7zdpqfct">
            <p data-id="element-242" data-mp="1mpkxwzniscmj">
              I designed Endo Blueprint™ to address this <strong className="text-ink" data-id="element-243" data-mp="1qu2demmuk3ri">organizational gap</strong>. Not by
              promising instant answers. Not by replacing your clinical training.
            </p>
            <p className="font-semibold text-navy" data-id="element-244" data-mp="z23b7ij444qf">
              But by giving you a structured visual reference that helps you organize the knowledge you already have.
            </p>
          </div>
        </div>
        <TransformCta label="I Want to Organize My Knowledge" data-id="element-245" data-mp="1829jmpzyeeiq" />
      </div>
    </section>;
}